import {page} from '@commercial-website/analytics'
import {hasAdvertisingConsent} from '@commercial-website/consent'
import {pushEvent} from '@commercial-website/observability'
import type {GatsbyBrowser} from 'gatsby'

import {queueParamCookies} from '@/config/param-cookies'
import {Freshchat} from '@/utils/freshchat'
import hasCookieExperiment from '@/utils/has-cookie-experiment'
import {updateSessionTrackingCookies} from '@/utils/track-session'

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({location}) => {
    if (location.search) {
        queueParamCookies(new URLSearchParams(location.search))
    }

    if (hasAdvertisingConsent()) {
        updateSessionTrackingCookies()
    }

    // The page path without the locale segment, e.g. `/pricing` instead of `/en/pricing`
    const rawPath = `/${location.pathname.split('/').slice(2).join('/')}`

    page({
        rawPath,
    })

    pushEvent('navigation', {
        url: location.pathname,
    })

    const shouldUseFreshchat = hasCookieExperiment({
        experimentName: 'chatbot',
        bucketName: 'freshchat',
    })

    if (shouldUseFreshchat) {
        Freshchat.updateVisibility()
    }
}
